export { default as Judging } from "../evaluation/main";

import routes from "./routes";
import * as Anchors from "./anchors";
export default {
  routes,
  Anchors,
};
